isAccordionExpanded = (item) -> item.classList.contains 'show'

toggleAccordion = (item) ->
  if isAccordionExpanded(item)
    hideAccordion(item)
  else
    showAccordion(item)

hideAccordion = (item) -> item.classList.remove 'show'
showAccordion = (item) -> item.classList.add 'show'

document.addEventListener 'DOMContentLoaded', ->
  toggles = document.querySelectorAll('.js-accordion-toggle')
  toggles.forEach (toggle) =>
    toggle.addEventListener 'click', (e) ->
      e.preventDefault()
      item = e.currentTarget.closest('.js-accordion-item')
      toggleAccordion(item)

